export default __webpack_public_path__ + "static/media/logo-rcca-bg-white.77a8c30e.jpeg";